import { IGridHeaderProps } from './types';
import GridHeaderCell from './Cells/GridHeaderCell';

import styles from './styles.module.scss';

const GridHeader = ({
  columns, sorting, onColumnHeaderClick, onSortingChange,
}: IGridHeaderProps) => (
  <thead>
    <tr className={styles.header}>
      {columns.map((column) => (
        <GridHeaderCell
          key={`${column.header.columnName}-${column.dataKey}`}
          column={column}
          sorting={sorting}
          onClick={onColumnHeaderClick}
          onSortingChange={onSortingChange}
        />
      ))}
    </tr>
  </thead>
);

export default GridHeader;
